import { CustomButton, LoadingButton } from '@hivediversity/common-lib/buttons';
import { colors } from '@hivediversity/common-lib/constant';
import { InputCustom } from '@hivediversity/common-lib/inputs';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { getIsLoading, getError } from 'store/authorization/selectors';

import { Form, WrapperForm, FormGroup, WrapperForgot } from './styled';

const LoginForm = ({ handleSubmit, submitForm }) => {
  const isLoading = useSelector(getIsLoading);
  const error = useSelector(getError);

  const handleRecovery = () => {
    window.location.href = '/recovery';
  };

  return (
    <Form onSubmit={handleSubmit}>
      <WrapperForm>
        <FormGroup>
          <InputCustom
            name="email"
            type="email"
            placeholder="Email"
            onKeyDown={e => (e.charCode || e.keyCode) === 13 && submitForm()}
            $bsStyle={{ maxWidth: '298px' }}
          />
          <label style={{ color: '#fff', fontWeight: '600' }}>
            <ErrorMessage className="invalid-feedback-style" component="span" name="email" />
          </label>
        </FormGroup>
        <FormGroup>
          <InputCustom
            name="password"
            type="password"
            placeholder="Password"
            onKeyDown={e => (e.charCode || e.keyCode) === 13 && submitForm()}
            $bsStyle={{ maxWidth: '298px' }}
          />
          <label style={{ color: '#fff', fontWeight: '600' }}>
            <ErrorMessage className="invalid-feedback-style" component="span" name="password" />
          </label>
        </FormGroup>
        <WrapperForgot onClick={handleRecovery}>FORGOT YOUR PASSWORD</WrapperForgot>
        <FormGroup>
          <LoadingButton
            component={CustomButton}
            color={colors.VIOLET}
            type="submit"
            label="sign in"
            isLoading={isLoading}
            $bsStyle={{ maxWidth: '160px' }}
            greyDisabled
          />
        </FormGroup>
      </WrapperForm>
      <p className="font-gentleman-regular" style={{ color: '#FF00FF', textAlign: 'center', fontWeight: '600' }}>
        {error}
      </p>
    </Form>
  );
};

LoginForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
};

export default LoginForm;
